<template>
    <Breadcrumbs></Breadcrumbs>    
    <Catalogslist></Catalogslist>
</template>

<script>

import Catalogslist from '@/views/Catalogslist.vue'
import Breadcrumbs from "@/components/Breadcrumbs.vue";

export default{
    name : "CatalogsViews",
    components: {        
        Catalogslist,
        Breadcrumbs
    }    
}
</script>
